export default __webpack_public_path__ + "static/media/accordIcon.042a65f0.svg";